import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ResetPasswordComponent } from '@app/auth/components/reset-password/reset-password.component';
import { SharedModule } from '@app/shared/shared.module';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { LoginPageComponent } from './components/login-page/login-page.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, SharedModule, CdkStepperModule],
  exports: [LoginPageComponent, LoginFormComponent],
  declarations: [LoginPageComponent, LoginFormComponent, ResetPasswordComponent],
})
export class AuthModule {}
